/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.links-menu-extension.alignment.title': '配置',
  'company-hub.links-menu-extension.all.borders.label-text': 'すべての枠線',
  'company-hub.links-menu-extension.background.color': '背景色',
  'company-hub.links-menu-extension.background.title': '背景',
  'company-hub.links-menu-extension.border.color': '枠線の色',
  'company-hub.links-menu-extension.border.position': '枠線の位置',
  'company-hub.links-menu-extension.bottom.border.label-text': '下の枠線',
  'company-hub.links-menu-extension.center.option': '中央揃え',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': '重要なリンクを追加',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'リンク',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': '関連するリンクをグループ化',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    '入れ子レベルの最大数に達しました。',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'メニュー',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'キャンセル',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': '削除',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'この操作により、このアイテムとすべての入れ子アイテムが削除されます。',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'アイテムの削除',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'サブ アイテムを追加',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'アイテムを削除',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'プロパティを編集',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': '下に移動',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': '上に移動',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'リンクを開く',
  'company-hub.links-menu-extension.config-panel.items.label': 'アイテム',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'リンク メニューに追加できる項目数の上限に達しました。',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': '新規アイテム',
  'company-hub.links-menu-extension.config-panel.preamble':
    'リンクを追加してサブメニューで整理します。{linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'リンク メニューの詳細',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'リンクを追加してサブメニューで整理します。',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'キャンセル',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': '確定',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error':
    'このフィールドに入力してください。',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': '表示テキスト',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'アイテム名',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': '確定',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'さらに表示',
  'company-hub.links-menu-extension.config-panel.styles.label': 'スタイル',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'リンク メニューに追加できる項目数の上限に達しました。',
  'company-hub.links-menu-extension.config-panel.title': 'リンク メニュー',
  'company-hub.links-menu-extension.fixed.option': '最上部に固定',
  'company-hub.links-menu-extension.left.option': '左寄せ',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'さらに表示',
  'company-hub.links-menu-extension.manifest.extension-description': '会社ハブに複数のリンクとサブメニューを追加します',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'リンク メニュー',
  'company-hub.links-menu-extension.manifest.extension-title': 'リンク メニュー [新機能]',
  'company-hub.links-menu-extension.manifest.first-default-item': '当社について',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'チーム 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'メリット',
  'company-hub.links-menu-extension.manifest.third-default-item': 'チーム',
  'company-hub.links-menu-extension.no.border.label-text': 'なし',
  'company-hub.links-menu-extension.right.option': '右寄せ',
  'company-hub.links-menu-extension.section.collapse.label': 'セクションを折りたたむ',
  'company-hub.links-menu-extension.section.expand.label': 'セクションを展開',
  'company-hub.links-menu-extension.selected.state.color': '選択時の色',
  'company-hub.links-menu-extension.text.color': 'テキストの色',
  'company-hub.links-menu-extension.text.title': 'テキスト',
};
